import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
  getContractsHistory (query) {
    let url = config.api.baseUrl + '/api/v2/history/contracts'

    if (query) {
      let esc = encodeURIComponent
      let _query = Object.keys(query)
        .map(k => esc(k) + '=' + esc(query[k]))
        .join('&')

      url += '?' + _query
    }

    return HTTP
      .request()
      .get(url)
      .then(response => response)
      .catch(error => error)
  },
  exportContracts (data) {
    let url = config.api.baseUrl + '/api/v2/history/contracts/export'

    return HTTP
      .request()
      .post(url, data, {
        responseType: 'arraybuffer'
      })
      .then(response => response)
      .catch(error => error)
  },
  getContractsSDAHistory (query) {
    let url = config.api.baseUrl + '/api/v2/history/sda'

    if (query) {
      let esc = encodeURIComponent
      let _query = Object.keys(query)
        .map(k => esc(k) + '=' + esc(query[k]))
        .join('&')

      url += '?' + _query
    }

    return HTTP
      .request()
      .get(url)
      .then(response => response)
      .catch(error => error)
  },
}



// WEBPACK FOOTER //
// ./src/api/contractsHistory.js